import React from "react";
import { NavLink } from "react-router-dom";
import { Card, CardBody, CardTitle, CardSubtitle } from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./SubscriptionCard.css";
import GlobalContext from "../../../../../../../Context/GlobalContext";
import rounded_back from "../../../../../../../Assets/images/round-background-matching-plat.png";
import { useTranslation } from "react-i18next"; // <-- importer useTranslation


export default function SubscriptionCard(props) {
  const { setSelectedSubsId } = React.useContext(GlobalContext);
  const { t } = useTranslation(); 

  const maxLength = 300; // Nombre maximum de caractères à afficher
  const truncatedDescription =
    props.subs.description_subs.length > maxLength
      ? props.subs.description_subs.substring(0, maxLength) + "..."
      : props.subs.description_subs;

  const descriptionArray = truncatedDescription.split('.').filter(Boolean); // Split by period and remove empty strings

  const handleEnSavoirPlusClick = () => {
    setSelectedSubsId(props.subs.id_subs);
  };
  
  return (
    <div className="subscription-card parent-container">
      <Card style={{ width: "18rem" }} className="h-100">
        <CardBody style={{ backgroundColor: '#F9F9F6', borderRadius: '20px', padding: '2rem' }}>
          <CardTitle tag="h2" style={{ color: "#3F4C52", textAlign: "center" }} className="card-title-abonner">
            {props.subs.name_subs}<br></br>
            <span className="text-muted m-l-10">
              <sup style={{color: "#2E2E2E", textTransform:'lowercase'}}>    {t("per_month")} </sup>
            </span>
          </CardTitle>
          <div className="subscription-details" style={{ backgroundImage: `url(${rounded_back})` }}>
            <h3 className="plan-price padding-b-15" style={{ color: '#FFFFFF', fontWeight: 400}}>
              {props.subs.price_subs} €
            </h3>
          </div>
          <CardSubtitle
            className="mb-2 abonner-description"
            tag="h6"
          >
            {descriptionArray.map((line, index) => (
              <React.Fragment key={index}>
                <span style={{ color: '#2E2E2E' }}>✔</span> {/* Apply green color */}
                {line.trim()} {/* Trim to remove leading/trailing whitespaces */}
                <br />
              </React.Fragment>
            ))}
          </CardSubtitle>
          <center>
            <NavLink
              to={`/public/subs/g/${props.subs.id_subs}`}
              className="btn btn-sm abonner"
              onClick={handleEnSavoirPlusClick}
            >
             {t("subscribe")}
            </NavLink>
          </center>
        </CardBody>
      </Card>
    </div>
  );
}
